import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DeactivateModalComponent } from './deactivate-modal/deactivate-modal.component';
import { ParkingManagerService } from '@core/services/parking-manager.service';
import {
  ManagerListReq,
  ManagerListResponse,
  ParkingLot,
  managerlist,
} from '@core/models/parking-manager.model';
import { Router } from '@angular/router';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { CommonMenuService } from '@shared/services/common-util.service';
import { MenuService } from '@core/services/menu.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
interface City {
  name: string;
  code: string;
}

@Component({
  selector: 'app-manager-list',
  templateUrl: './manager-list.component.html',
  styleUrls: ['./manager-list.component.scss'],
})
export class ManagerListComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  sidebarVisible: boolean = false;
  managerlist: managerlist[] = [];
  searchManagerName: string;
  searchContactNo: string;
  sideBardata: any = {};
  cities: City[];
  activeItem: any;
  parkingLotByStates: ParkingLot[];
  dummy: string = 'assets/images/dummy-img.png';
  selectedCities: City[];
  itemsPerPage: number = 10;
  totalItems: number = 0;
  first: number = 1;
  createManagerCheck : boolean = false;

  constructor(
    private readonly dialogControlService: DialogControlService, 
    private readonly parkingMangerService: ParkingManagerService,
    private readonly router: Router,
    private readonly commonMenuService: CommonMenuService,
    private readonly menuService: MenuService,
    private readonly encryptStorage: EncryptionStorageService
  ) { }

  logo: string = 'assets/images/table-img.png';
  dot: string = 'assets/images/dot.svg';
  date: Date[] | undefined;
  @Input() outlined: boolean = false;
  items: MenuItem[] | undefined;

  ngOnInit() {
    this.getManagerListByOwnerId();
    this.getParkingLotByStatesName();
    this.checkCreateManagerPermission();
  }

  createManager() {
    localStorage.removeItem('navigationFromView');
    this.router.navigateByUrl('/manager/createmanager'); 
  }
  checkCreateManagerPermission() {
    this.createManagerCheck = this.menuService.shortNameExists(
      JSON.parse(this.encryptStorage.getItem('menuData')),
      36
    );
  }
  private navigateToEditmanager() {
    this.router.navigate(['manager/editmanager'], {
      queryParams: { id: this.activeItem.id },
    });
  }

  showData(product: any) {
    const { isActive } = product;
    const [showStatus, showIcon] = isActive
      ? ['Deactivate', 'pi pi-times']
      : ['Activate', 'pi pi-check'];

    const actionMap = {
      edit: () => this.navigateToEditmanager(),
      previewTicket: () => this.openSuccessModal(this.activeItem),
    };

    const config = [
      {
        label: '',
        icon: '',
      },
      {
        label: 'Edit',
        icon: 'common-icon custom-editicon',
        command: actionMap.edit,
      },
      {
        label: showStatus,
        icon: showIcon,
        command: actionMap.previewTicket,
      },
    ];

    this.items = this.commonMenuService.commonShowData(config);
  }
  getParkingLotByStatesName() {
    this.parkingMangerService.getParkingLotByStatesName('')
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: ParkingLot[]) => {
        this.parkingLotByStates = response;
        
      },
    });
  }

  openSuccessModal(item) {
    this.dialogControlService.openDialog(DeactivateModalComponent, {
      width: '25%',
      data: {
        bodyText: item,
      },
    });
    this.dialogControlService.onClose().subscribe((result: string) => {
      if (result != 'cancel') {
        this.getManagerListByOwnerId();
      }
    });
  }

  getAssignedParkingByManagerId(id: string) {
    this.parkingMangerService.getAssignedParkingByManagerId(id)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.sideBardata = response;
        this.sidebarVisible = true;
        
      },
    });
  }

  getManagerListByOwnerId() {
    
    const req: ManagerListReq = {
      managerName: this.searchManagerName || '',
      contactNumber: this.searchContactNo || '',
      isActive: true,
      pageNumber: this.first,
      pageSize: 10,
    };

    this.parkingMangerService.getManagerListByOwnerId(req)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: ManagerListResponse) => {
        this.totalItems = response.totalRecords;
        this.managerlist = response.managerList;
},
      error: () => {
        this.managerlist = [];
      },
    });
  }

  reset() {
    this.searchContactNo = '';
    this.searchManagerName = '';
    this.first = 0;
    this.getManagerListByOwnerId();
  }

  filters() {
    this.first = 0;
    this.getManagerListByOwnerId();
  }

  openSidebarAndLoadParking(managerid: string) {
    this.getAssignedParkingByManagerId(managerid);
  }

  sideBar() {
    this.sidebarVisible = false;
  }

  onPageChange(event) {
    this.first = event.page + 1;
    this.getManagerListByOwnerId();
  }
}
